import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  FormControl,
  Form,
  Modal,
  Alert,
  InputGroup,
} from "react-bootstrap";
import {
  listarAreaCobertura,
  criarAreaCobertura,
  removeAreaCobertura,
  buscarAreaCobertura,
} from "../../providers/AreaCoberturaProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import TBLArea from "../../components/TBLArea";
import cep from "cep-promise";
import Select from "react-select";
import { ListarEstabelecimentosSemPaginacao } from "../../providers/EstabelecimentoProvider";

export default class AreaCobertura extends Component {
  constructor(props) {
    super(props);
    this.state = {
      areaSelecionada: null,
      showModalCreate: false,
      showModalAlert: false,
      errorCadastro: "",
      modoEditarArea: false,

      areasCobertura: [],
      estado: null,
      cidade: null,
      errorcidade: "",
      bairro: null,
      valor_frete: "",

      mensagemAlert: "",
      variantAlert: "",
      estabelecimentos: [],
      cep: "",
      pesquisa: "",

      estabelecimentoSelecionado: null,
      estabelecimentoSelecionadoModal: null,
    };
  }

  handleCloseModalCreate = () => {
    this.setState({ showModalCreate: false });
    this.limparForm();
  };

  handleShowModalCreate = () => {
    this.setState({
      showModalCreate: true,
      estabelecimentoSelecionadoModal: this.state.estabelecimentoSelecionado,
    });
  };

  handleShowAlert = (mensagem, variant) => {
    if (variant === "success") {
      toast.success(mensagem);
    } else {
      toast.error(mensagem);
    }
  };

  handleCloseModalAlert = () => {
    this.setState({ showModalAlert: false });
    this.limparForm();
  };

  handleShowModalAlert = () => {
    this.setState({ showModalAlert: true });
  };

  limparForm = () => {
    this.setState({
      areaSelecionada: null,
      showModalCreate: false,
      showModalAlert: false,
      errorCadastro: "",
      modoEditarArea: false,

      estado: "",
      cidade: "",
      bairro: "",
      cep: "",
      valor_frete: "",
      errorcidade: "",
      pesquisa: "",

      mensagemAlert: "",
      variantAlert: "",

      estabelecimentoSelecionadoModal: null,
    });
  };

  preencherFormEdit = (dados) => {
    this.setState({
      areaSelecionada: dados,
      estado: dados.estado,
      cidade: dados.cidade,
      bairro: dados.bairro,
      valor_frete: dados.valor_frete,
      modoEditarArea: true,
      estabelecimentoSelecionadoModal: this.state.estabelecimentoSelecionado,
    });
    this.handleShowModalCreate();
  };

  receberDadosTabela = (tipo, dados) => {
    if (tipo === "editar") {
      this.preencherFormEdit(dados);
    } else if (tipo === "deletar") {
      this.setState({ areaSelecionada: dados });
      this.handleShowModalAlert();
    } else {
      return;
    }
  };

  getCEP = async (ceps) => {
    cep(ceps)
      .then((obj) => {
        if (!obj.neighborhood || !obj.city || !obj.state) {
          return this.handleShowAlert("CEP inconsistente, tente outro", "danger");
        }
        this.setState({
          estado: obj.state,
          cidade: obj.city,
          bairro: obj.neighborhood,
        });
        this.handleShowAlert("Pesquisa feita com sucesso", "success");
      })
      .catch((error) => {
        this.handleShowAlert("Erro no campo CEP", "danger");
        console.log(error);
      });
  };

  cadastrarArea = async () => {
    let data = {};
    if (
      this.state.estado === null ||
      this.state.cidade === null ||
      this.state.bairro === null ||
      this.state.valor_frete === ""
    ) {
      this.setState({ errorCadastro: "Informações obrigatórias faltando" });
    } else {
      data = {
        estado: this.state.estado,
        cidade: this.state.cidade,
        bairro: this.state.bairro,
        valor_frete: this.state.valor_frete,
      };
      const idEstab = this.state.estabelecimentoSelecionadoModal?.value;
      try {
        const response = await criarAreaCobertura(data, idEstab);
        if (response) {
          const estabelecimento = await listarAreaCobertura(idEstab);
          this.setState({ areasCobertura: estabelecimento.area_cobertura });
          this.limparForm();
          this.handleShowAlert("Área criada com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert("Este bairro já foi cadastrado", "danger");
      }
    }
  };

  editarArea = async (area) => {
    let data = {};
    if (
      this.state.estado === null ||
      this.state.cidade === null ||
      this.state.bairro === null ||
      this.state.valor_frete === ""
    ) {
      this.setState({ errorCadastro: "Informações obrigatórias faltando" });
    } else {
      data = {
        estado: this.state.estado,
        cidade: this.state.cidade,
        bairro: this.state.bairro,
        valor_frete: this.state.valor_frete,
      };
      const idEstab = this.state.estabelecimentoSelecionadoModal?.value;
      try {
        await removeAreaCobertura(area._id, idEstab);
        const response = await criarAreaCobertura(data, idEstab);
        if (response) {
          const estabelecimento = await listarAreaCobertura(idEstab);
          this.setState({ areasCobertura: estabelecimento.area_cobertura });
          this.limparForm();
          this.handleShowAlert("Área editada com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert("Erro ao editar área", "danger");
      }
    }
  };

  deletarArea = async (area) => {
    try {
      const idEstab = this.state.estabelecimentoSelecionado?.value;
      const response = await removeAreaCobertura(area._id, idEstab);
      if (response) {
        const list = await listarAreaCobertura(idEstab);
        this.setState({ areasCobertura: list.area_cobertura });
        this.limparForm();
        this.handleShowAlert("Área deletada com sucesso", "success");
      }
    } catch (error) {
      this.handleShowAlert("Erro ao deletar área de cobertura", "danger");
    }
  };

  listarArea = async (estab) => {
    if (!estab) {
      this.setState({ areasCobertura: [] });
      return this.limparForm();
    }
    const response = await listarAreaCobertura(estab);
    this.setState({ areasCobertura: response.area_cobertura });
  };

  async componentDidMount() {
    const estabelecimentos = await ListarEstabelecimentosSemPaginacao();
    const estabelecimentosFormatted = estabelecimentos.map((a) => ({
      nome: a.nome_fantasia,
      id: a._id,
    }));
    this.setState({ estabelecimentos: estabelecimentosFormatted });
  }

  buscarAreas = async (busca) => {
    const idEstab = this.state.estabelecimentoSelecionado?.value;
    if (busca && idEstab) {
      const response = await buscarAreaCobertura(busca, idEstab);
      if (response) {
        this.setState({ areasCobertura: response.area_cobertura });
      } else {
        this.setState({ areasCobertura: [] });
      }
    } else if (busca === null) {
      await this.listarArea(idEstab);
    }
  };

  render() {
    return (
      <div style={{ margin: 10, marginLeft: 50, marginRight: 50 }}>
        {this.state.showAlert ? (
          <Alert style={{ zIndex: 99999999999 }} variant={this.state.variantAlert}>
            {this.state.mensagemAlert}
          </Alert>
        ) : null}
        <br></br>
        <Row>
          <Col md={9}>
            <h3>Área de Cobertura</h3>
          </Col>
        </Row>
        <br></br>
        <Row>
          <Col>
            <Form>
              <Form.Group>
                <Form.Label>Escolha o Estabelecimento *</Form.Label>
                <Row>
                  <Col md={6}>
                    <Select
                      isDisabled={!this.state.estabelecimentos?.length}
                      value={this.state.estabelecimentoSelecionado}
                      isClearable
                      isSearchable
                      onChange={(opt) => {
                        this.setState({
                          estabelecimentoSelecionado: opt,
                          estabelecimentoSelecionadoModal: opt,
                        });
                        this.listarArea(opt?.value);
                      }}
                      options={this.state.estabelecimentos?.map((i) => ({
                        label: i.nome,
                        value: i.id,
                      }))}
                      placeholder="Estabelecimento"
                    />
                  </Col>
                  <Col>
                    <Button
                      onClick={() => {
                        this.handleShowModalCreate();
                      }}
                    >
                      Cadastrar Área de Cobertura
                    </Button>
                  </Col>
                </Row>
              </Form.Group>
            </Form>
          </Col>
        </Row>
        <br></br>

        <div>
          <Row>
            <Col md={6}>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  value={this.state.pesquisa}
                  placeholder="Pesquisar por estado, cidade ou bairro"
                  onChange={(e) => this.setState({ pesquisa: e.target.value })}
                />
              </InputGroup>
            </Col>
            <Col md={1}>
              <Button
                variant="primary"
                onClick={(e) => {
                  this.buscarAreas(this.state.pesquisa);
                }}
              >
                Pesquisar
              </Button>
            </Col>
            <Button
              variant="secondary"
              onClick={() => {
                this.setState({ pesquisa: "" });
                this.buscarAreas(null);
              }}
            >
              Limpar
            </Button>
          </Row>
          <br></br>
          <TBLArea
            data={this.state.areasCobertura}
            numRows={13}
            dataCallback={this.receberDadosTabela}
          ></TBLArea>
        </div>

        <Modal
          size="xl"
          show={this.state.showModalCreate}
          onHide={this.handleCloseModalCreate}
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>
              {this.state.modoEditarArea
                ? "Editar Área de Cobertura"
                : "Cadastrar Área de Cobertura"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.errorCadastro ? (
              <div>
                <p style={{ color: "red" }}>{this.state.errorCadastro}</p>
              </div>
            ) : null}
            <Form>
              <Form.Group>
                <Form.Label>Escolha o Estabelecimento *</Form.Label>
                <Select
                  isDisabled={!this.state.estabelecimentos?.length}
                  value={this.state.estabelecimentoSelecionadoModal}
                  isClearable
                  isSearchable
                  onChange={(opt) => {
                    this.setState({
                      estabelecimentoSelecionadoModal: opt,
                    });
                  }}
                  options={this.state.estabelecimentos?.map((i) => ({
                    label: i.nome,
                    value: i.id,
                  }))}
                  placeholder="Estabelecimento"
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Insira seu CEP *</Form.Label>
                <Form.Control
                  value={this.state.cep}
                  placeholder="00000-000"
                  type="text"
                  onChange={(e) => {
                    this.setState({ cep: e.target.value });
                  }}
                ></Form.Control>
                <br></br>
                <Button
                  variant="primary"
                  onClick={(e) => {
                    this.getCEP(this.state.cep);
                  }}
                >
                  Pesquisar
                </Button>
              </Form.Group>
              <Form.Group>
                <Form.Label>Estado *</Form.Label>
                <Form.Control
                  value={this.state.estado}
                  disabled
                  type="text"
                  onChange={(e) => {
                    this.setState({ estado: e.target.value });
                  }}
                ></Form.Control>
              </Form.Group>
              <Form.Group>
                <Form.Label>Cidade *</Form.Label>
                <Form.Control
                  value={this.state.cidade}
                  disabled
                  type="text"
                  onChange={(e) => {
                    this.setState({ cidade: e.target.value });
                  }}
                ></Form.Control>
              </Form.Group>
              <Form.Group>
                <Form.Label>Bairro</Form.Label>
                <Form.Control
                  value={this.state.bairro}
                  disabled
                  type="text"
                  onChange={(e) => {
                    this.setState({ bairro: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Valor do frete *</Form.Label>
                <Form.Control
                  value={this.state.valor_frete}
                  type="number"
                  min={0}
                  placeholder="R$ 00,00"
                  onChange={(e) => {
                    if (e.target.value < 0) {
                      let valor = e.target.value * -1;
                      this.setState({ valor_frete: valor });
                    } else {
                      this.setState({ valor_frete: e.target.value });
                    }
                  }}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalCreate();
              }}
            >
              Fechar
            </Button>
            {this.state.modoEditarArea ? (
              <Button
                variant="primary"
                onClick={() => {
                  this.editarArea(this.state.areaSelecionada);
                }}
              >
                {"Editar"}
              </Button>
            ) : (
              <Button
                variant="primary"
                onClick={() => {
                  this.cadastrarArea();
                }}
              >
                {"Cadastrar"}
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        <Modal
          size="sm"
          show={this.state.showModalAlert}
          onHide={this.handleCloseModalAlert}
        >
          <Modal.Header closeButton>
            <Modal.Title>Alerta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Deseja realmente excluir a área de cobertura?</p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalAlert();
              }}
            >
              Não
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                this.deletarArea(this.state.areaSelecionada);
              }}
            >
              Sim
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
